/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	SOFTWARE_PROJECT,
	toProjectType,
} from '@jira/platform__project-types/src/project-types.tsx';
import {
	type ApplicationEditions,
	PREMIUM_EDITION,
} from '@jira/platform__application-editions/src/edition.tsx';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

// Only show if a software project is open and premium
export const isProjectTypeAndEditionSupported = (
	applicationEditions: ApplicationEditions,
	project?: string,
): Boolean => {
	const projectType = toProjectType(project);

	if (!projectType || projectType !== SOFTWARE_PROJECT) {
		return false;
	}

	return applicationEditions.software === PREMIUM_EDITION;
};

// Get days config object
export const getDaysConfig = (): {
	days_left_for_message_1?: number;
	days_left_for_message_2?: number;
	days_left_for_message_3?: number;
} => {
	// Firing exposure to add analytics
	const config = FeatureGates.getExperiment('rec_premium_to_standard_days_modal_shown');

	return config.get<{
		days_left_for_message_1?: number;
		days_left_for_message_2?: number;
		days_left_for_message_3?: number;
	}>('value', {});
};

// Get days to show modal from dynamic config
export const getDaysToShowModalDynamicConfig = (): number[] => {
	const daysConfig = getDaysConfig();

	const validDays = [
		daysConfig.days_left_for_message_1,
		daysConfig.days_left_for_message_2,
		daysConfig.days_left_for_message_3,
	].filter((day): day is number => typeof day === 'number');

	// fall back to hard coded days if dynamic config does not return a value
	if (validDays.length === 0) {
		return [5, 3, 1];
	}

	return validDays;
};

// Get message Id for day left in trial
export const getMessageIdForDaysLeft = (daysLeft: number): string | undefined => {
	const daysConfig = getDaysConfig();

	if (daysLeft === daysConfig.days_left_for_message_1) {
		return 'prj-grace-period-recc-standard-msg-1';
	}
	if (daysLeft === daysConfig.days_left_for_message_2) {
		return 'prj-grace-period-recc-standard-msg-2';
	}
	if (daysLeft === daysConfig.days_left_for_message_3) {
		return 'prj-grace-period-recc-standard-msg-3';
	}
	return undefined;
};
